<pla-custom-loader-box *ngIf="loadingTexts" [classes]="'py-0 mb-4'" [almostComplete]="almostComplete"
  [loadingTexts]="loadingTexts" [car]="'G_WAGON'" [barColour]="'#5f6f40'"></pla-custom-loader-box>